export const DELAY_FOCUS = 100;
